export default function Settings() {
  return (
    <div>
      <h2>Settings</h2>
    </div>
  );
}